import {
	HttpClient,
	HttpContext,
	HttpContextToken,
	HttpParams,
	HttpParamsOptions,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, filter, skip, switchMap, take, tap } from 'rxjs';
import { selectConfig } from '../store/selectors/config.selector';

export const HIDE_LOADING = 'hideLoading';

@Injectable({
	providedIn: 'root',
})
export class ApiService {

	constructor(		
		private http: HttpClient,
		private store: Store
	) {console.log('API SERVICE CONSTRUCTOR')}

	get<T>(path: string, params: any = {}): Observable<any> {
		console.log('PATH:', path)
		console.log('PARAMS:', params)
		return this.store.select(selectConfig).pipe(
			filter(x => x.data['FORM_API']),
			take(1),
			switchMap((config) => {
				console.log('ENDPOINT:', `${config.data['FORM_API']}${path}`)
				return this.http.get<T>(
					`${config.data['FORM_API']}${path}`,
					params
				)
			})
		)
	}

	put<T>(path: string, body: any, options?: any): Observable<any> {
		console.log('PATH:', path)
		console.log('BODY:', body)
		return this.store.select(selectConfig).pipe(
			filter(x => x.data['FORM_API']),
			take(1),
			switchMap((config) => {
				console.log('ENDPOINT:', `${config.data['FORM_API']}${path}`)
				return this.http.put<T>(
					`${config.data['FORM_API']}${path}`,
					body,
					options
				)
			})
		)
	}

	patch<T>(path: string, body: any, options?: any): Observable<any> {
		console.log('PATH:', path)
		console.log('BODY:', body)
		return this.store.select(selectConfig).pipe(
			filter(x => x.data['FORM_API']),
			take(1),
			switchMap((config) => {
				console.log('ENDPOINT:', `${config.data['FORM_API']}${path}`)
				return this.http.patch<T>(
					`${config.data['FORM_API']}${path}`,
					body,
					options
				)
			})
		)
	}

	post<T>(path: string, body: object, options?: any): Observable<any> {
		console.log('PATH:', path)
		console.log('BODY:', body)
		return this.store.select(selectConfig).pipe(
			filter(x => x.data['FORM_API']),
			take(1),
			switchMap((config) => {
				console.log('ENDPOINT:', `${config.data['FORM_API']}${path}`)
				return this.http.post<T>(
					`${config.data['FORM_API']}${path}`,
					body,
					options
				)
			})
		)
	}

	delete<T>(path: string, body: any): Observable<any> {
		console.log('PATH:', path)
		console.log('BODY:', body)
		return this.store.select(selectConfig).pipe(
			filter(x => x.data['FORM_API']),
			take(1),
			switchMap((config) => {
				console.log('ENDPOINT:', `${config.data['FORM_API']}${path}`)
				return this.http.delete<T>(
					`${config.data['FORM_API']}${path}`,
					body
				)
			})
		)
	}

	getFullPath<T>(path: string, params: any = {}): Observable<any> {
		return this.http.get<T>(`${path}`, params);
	}
}

export function customHttpParam(param: any) {
	return new CustomHttpParams(param);
}

class CustomHttpParams extends HttpParams {
	constructor(public params?: { [param: string]: string | string[] }) {
		super({ fromObject: params } as HttpParamsOptions);
	}
}
